<script>
import { nextTick } from 'vue';
import { useDisplay } from 'vuetify';
import { getDates } from '@/services/DateServices';
import { getAllReasonsFromDbase } from '@/services/ReasonsServices';
import { getLatestWRPFromDbase } from '@/services/WeeklyReviewPreviewServices';
import { getOneSelfCheckIn } from '@/services/SelfCheckInServices';
import { getProgramFromDbase } from '@/services/ProgramServices';
import { getAllWinsForTodayFromDbase } from '@/services/WinsServices';
import { compareTodaysWinsToProgramThenUpdateIfNeeded } from '@/services/DashboardServices';
import { getBigTaskFromDbase } from '@/services/BigTaskServices';
import { getAllSmallTasksFromDbase } from "@/services/SmallTasksServices";
import DashDatePicker from './DashDatePicker.vue';
import ReasonsDisplay from './ReasonsDisplay.vue';
import SelfCheckIn from './SelfCheckIn.vue';
import ThisWeeksTargetGoals from './ThisWeeksTargetGoals.vue';
import WinsStacker from './WinsStacker.vue';
import BigTask from './BigTask.vue';
import SmallTasks from './SmallTasks.vue';
import EodReviewPreview from './EodReviewPreview.vue';

export default {
  props: [ 'todaysDate' ],
  components: {
    DashDatePicker,
    ReasonsDisplay,
    SelfCheckIn,
    ThisWeeksTargetGoals,
    WinsStacker,
    BigTask,
    SmallTasks,
    EodReviewPreview,
  },
  setup() { // Options API + Vuetify composable (works fine)
    const display = useDisplay(); // reactive object
    return { display };
  },
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),

      mainTargetForThisWeek: null,

      loading: true,
      stackAccordions: null,
      // internal helpers
      restoreTimer: null,
      prevAccordionValue: null,

      selfCheckIn: {},
      todaysWins: [],
      bigTask: {},
      smallTasks: [],
    };
  },
  computed: {
    todayActual() { // actual date of today
      return this.$store.getters['todayActual'];
    },
    today() { // the day that we're CRUDing
      return this.$store.getters['today'];
    },
    reasons() {
      return this.$store.getters['reasons'];
    },
    program() {
      return this.$store.getters['program'];
    },
    checkIn() {
      return this.$store.getters['selfcheckin/todaysSelfCheckIn'];
    },
  },
  watch: {
    async todaysDate() {
      document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
      // this.stackAccordions = 0;

      await this.setDates();

      await this.hardRefresh([ 'todaysWins', 'todaysBigTask', 'todaysSmallTasks', 'todaysEodReviewPreview' ]);
      await this.checkWinsAgainstProgram();
    },
  },
  methods: {

    redirectIfNeeded() {
      let newRoute = '';
      if (this.display.mdAndUp.value) {
        newRoute = '/dash/';
        if (this.todaysDate) {
          newRoute = newRoute + this.todaysDate;
        }
      } else {
        newRoute = '/m/dash/';
        if (this.todaysDate) {
          newRoute = newRoute + this.todaysDate;
        }
      }
      this.$router.push(newRoute);
    },

    async setDates() {
      const d = getDates(this.todaysDate);
      await this.$store.dispatch('todayActual', d.todayActual);
      await this.$store.dispatch('tomorrowActual', d.tomorrowActual);
      await this.$store.dispatch('today', d.today);
      await this.$store.dispatch('todaysDateDisplay', d.todaysDateDisplay);
      await this.$store.dispatch('dayOfWeek', d.dayOfWeek);
    },

    onDatePickerClick(e) {
      // only respond to the date picker buttons (Vuetify v-btn -> button)
      const btn = e.target.closest('button');
      if (!btn) return;

      // cancel any pending restore from a previous click
      clearTimeout(this.restoreTimer);

      // remember what was open *before* we close it
      this.prevAccordionValue = this.stackAccordions;

      // close immediately (runs before child's @click)
      this.stackAccordions = null;

      // restore after 500ms (after child's logic has run)
      this.restoreTimer = setTimeout(() => {
        this.stackAccordions = this.prevAccordionValue;
      }, 850);
    },

    async getMainTargetForThisWeek() {
      const latestWRP = await getLatestWRPFromDbase(this.uId, this.token);
      if (latestWRP) {
        Object.keys(latestWRP).forEach(key => {
          const weekToPreview = latestWRP[key].weekToPreview.map(d => d.value);
          if (weekToPreview.includes(this.today)) {
            this.mainTargetForThisWeek = latestWRP[key].mainTargetForUpcomingWeek;
          }
        });
      }
    },

    async checkWinsAgainstProgram() {
      const updatedWins = await compareTodaysWinsToProgramThenUpdateIfNeeded(this.uId, this.token, this.today, this.todayActual, this.program, this.todaysWins);
      if (updatedWins) {
        await this.hardRefresh(['todaysWins']);
      }
    },

    async refreshDemSmallTasks() {
      this.smallTasks = await getAllSmallTasksFromDbase(this.uId, this.token, this.today);
    },

    async hardRefresh(listOfThingsToUpdate) {

      this.loading = true;

      if (listOfThingsToUpdate.includes('reasons')) {
        const reasons = await getAllReasonsFromDbase(this.uId, this.token);
        await this.$store.dispatch('reasons', reasons);
      }

      if (listOfThingsToUpdate.includes('selfCheckIn')) {
        this.selfCheckIn = await getOneSelfCheckIn(this.uId, this.token, this.today);
      }

      if (listOfThingsToUpdate.includes('program')) {
        const p = await getProgramFromDbase(this.uId, this.token);
        await this.$store.dispatch('program', p);
        // console.log('*** got da program ***', p);
      }

      if (listOfThingsToUpdate.includes('todaysWins')) {
        this.todaysWins = await getAllWinsForTodayFromDbase(this.uId, this.token, this.today);
        // console.log('***** this is todaysWins *****', this.todaysWins);
      }

      if (listOfThingsToUpdate.includes('todaysBigTask')) {
        const bigTaskFromDbase = await getBigTaskFromDbase(this.uId, this.token, this.today);
        this.bigTask = bigTaskFromDbase;
        this.$store.dispatch('program/todaysBigTask', bigTaskFromDbase);
      }

      if (listOfThingsToUpdate.includes('todaysSmallTasks')) {
        this.smallTasks = await getAllSmallTasksFromDbase(this.uId, this.token, this.today);
      }


      this.loading = false;
    },

    async scrollToTasksInProgramAccordion() {
      const clickProgramAccordion = document.getElementById('accordion-program-title');
      if (clickProgramAccordion) {
        clickProgramAccordion.click();
      }

      await nextTick();
      const targetElement = document.getElementById('section-big-task-for-today');
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    },

    async clickedDashTab(tab) {
      const eightHours = 60 * 60 * 8;
      await this.$cookies.set('lastViewedDash', tab, eightHours);
    },

    async createWinsFromProgramForADayThatIsNotToday() {
      console.log('*** starting createWinsFromProgramForADayThatIsNotToday() ***');
      await this.checkWinsAgainstProgram();
      this.$nextTick(() => {
        window.location.reload();
      });
    },

  },
  async created() {
    console.clear();

    // prepare dates
    await this.setDates();

    // add to store: uId, token
    await this.$store.dispatch('uId', this.uId);
    await this.$store.dispatch('token', this.token);

    await this.getMainTargetForThisWeek();

    // GET & SET all Data used in all Dashboard tabs/accordions
    await this.hardRefresh([
      'reasons',
      'selfCheckIn',
      'program',
      'todaysWins',
      'todaysBigTask',
      'todaysSmallTasks',
    ]);

    // check program against program -- this check is optional if the today (from url) != todayActual
    if (this.todayActual == this.today ) {
      await this.checkWinsAgainstProgram();
    }

    // open the lastViewedDash
    const dashTab = await this.$cookies.get('lastViewedDash');
    if (dashTab) {
      this.stackAccordions = parseInt(dashTab);
    } else {
      this.stackAccordions = 0;
    }

  },
  mounted() {
    this.redirectIfNeeded();
    window.scrollTo(0, 0);
  },
  beforeUnmount() {
    clearTimeout(this.restoreTimer);
  },
};
</script>

<template>
  <div @click.capture="onDatePickerClick">
    <DashDatePicker />
  </div>

  <div id="dashboard" class="px-2 py-4">
    <v-expansion-panels v-model="stackAccordions">

      <!-- REASONS -->
      <v-expansion-panel id="accordion-reasons" @click="clickedDashTab('0')">
        <v-expansion-panel-title>Remember 2 Remember:</v-expansion-panel-title>
        <v-expansion-panel-text>
          <ReasonsDisplay :mainTargetForThisWeek="mainTargetForThisWeek" />
        </v-expansion-panel-text>
      </v-expansion-panel>


      <!-- MORNING SELF-CHECK-IN -->
      <v-expansion-panel id="accordion-self-check-in" @click="clickedDashTab('1')">
        <v-expansion-panel-title>MORNING CHECK-IN</v-expansion-panel-title>
        <v-expansion-panel-text>
          <SelfCheckIn :propSelfCheckIn="selfCheckIn" @scrollToTasks="scrollToTasksInProgramAccordion" />
        </v-expansion-panel-text>
      </v-expansion-panel>


      <!-- PROGRAM -->
      <v-expansion-panel id="accordion-program" :key="$route.path" @click="clickedDashTab('2')">
        <v-expansion-panel-title id="accordion-program-title">PROGRAM</v-expansion-panel-title>
        <v-expansion-panel-text>
          <ThisWeeksTargetGoals :mainTargetForThisWeek="mainTargetForThisWeek" />
          <WinsStacker :propTodaysWins="todaysWins" @create-wins-for-not-today-actual="createWinsFromProgramForADayThatIsNotToday" />
          <BigTask :propBigTask="bigTask" />
          <SmallTasks :propSmallTasks="smallTasks" />
        </v-expansion-panel-text>
      </v-expansion-panel>


      <!-- EOD REVIEW/PREVIEW -->
      <v-expansion-panel id="accordion-review-preview" @click="clickedDashTab('3')">
        <v-expansion-panel-title>EOD Report</v-expansion-panel-title>
        <v-expansion-panel-text>
          <EodReviewPreview :mainTargetForThisWeek="mainTargetForThisWeek" />
        </v-expansion-panel-text>
      </v-expansion-panel>

    </v-expansion-panels>
  </div>

  <div @click.capture="onDatePickerClick" class="mt-8 mb-2">
    <DashDatePicker />
  </div>
</template>

<style lang="scss" scoped>
#dashboard {
  min-height: 75vh;
  @media screen and (min-width: 768px) {
    padding-left: 0;
    padding-right: 0;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }
}
.v-expansion-panel > .v-expansion-panel-title {
  background-color: #EEEEEE;
}
.v-expansion-panel--active > .v-expansion-panel-title {
  background-color: #66BB6A;
  color: white;
  font-weight: bold;
  font-size: 1em;
}
.v-expansion-panel-title {
  text-transform: uppercase;
}
</style>
